import { InjectionToken } from '@angular/core';

export type URL_MATCHES = Array<RegExp | string>;

export const CacheableURLsInjectionToken = new InjectionToken<URL_MATCHES>('CacheableURLs');
